import * as React from "react";

export const IconSave = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_30439_35793)">
      <path
        d="M14.1667 3L4.16667 3C3.24167 3 2.5 3.75 2.5 4.66667L2.5 16.3333C2.5 17.25 3.24167 18 4.16667 18H15.8333C16.75 18 17.5 17.25 17.5 16.3333V6.33333L14.1667 3ZM10 16.3333C8.61667 16.3333 7.5 15.2167 7.5 13.8333C7.5 12.45 8.61667 11.3333 10 11.3333C11.3833 11.3333 12.5 12.45 12.5 13.8333C12.5 15.2167 11.3833 16.3333 10 16.3333ZM12.5 8L4.16667 8L4.16667 4.66667L12.5 4.66667V8Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_30439_35793">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
